// removed by extract-text-webpack-plugin
module.exports = {"text":"style__text__3ypm_","yearly_check":"style__yearly_check__3YOSv","plans":"style__plans__2Ru3N","plan":"style__plan__3TOlm","subprice":"style__subprice__1exPU","price":"style__price__HTqjB","selected":"style__selected__2SXxl","customPlans":"style__customPlans__16dww","subtitle":"style__subtitle__1enxU","customText":"style__customText__1R4pJ","loadingPopup":"style__loadingPopup__3v58T","successPopup":"style__successPopup__22Y0Q","successContainer":"style__successContainer__YWkv5","successReturn":"style__successReturn__16jjm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/subscriptions/modal/ui/style.scss
// module id = 156
// module chunks = 0